exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".NextButton__button___3EtH-, .NextButton__disabledButton___2RB08 {\n  border: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 14px;\n  font-weight: bold;\n  border-radius: 5px;\n  cursor: pointer;\n  width: 262px;\n  height: 50px; }\n  @media (max-width: 576px) {\n    .NextButton__button___3EtH-, .NextButton__disabledButton___2RB08 {\n      display: block;\n      width: 100%;\n      text-align: center;\n      background-color: white;\n      margin-left: 0;\n      box-shadow: none; } }\n\n.NextButton__button___3EtH- {\n  background-color: #f94144;\n  color: white; }\n\n.NextButton__button___3EtH- {\n  margin-top: 40px;\n  float: right; }\n\n.NextButton__disabledButton___2RB08 {\n  background-color: #fff;\n  color: #dedede;\n  cursor: not-allowed;\n  margin-top: 40px;\n  float: right; }\n", ""]);

// exports
exports.locals = {
	"button": "NextButton__button___3EtH-",
	"disabledButton": "NextButton__disabledButton___2RB08"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/SelectModulePage/TitleWithModule/NextButton/NextButton.scss
// module id = 5070
// module chunks = 6